module.exports = __webpack_public_path__ + "static/media/[Art_and_Music]2010-11-14.2ea48066.md";